export const GEMBA_WALK_ASSESSMENTS_GRAPH_SETTINGS_ROUTE = 'settings-gemba-walk-assessments-graph'
export const GEMBA_WALK_ASSESSMENTS_ROUTE = 'gemba-walk-assessments'
export const GEMBA_WALK_CATEGORIES = 'gemba-walk-categories'
export const GEMBA_WALK_FACE_TO_FACE_SOURCE = 'DRGembaWalkF2F'
export const GEMBA_WALK_KPIS = 'gemba-walk-kpis'
export const GEMBA_WALK_PREVIOUS_COMMENTS_TIME_SETTINGS_ROUTE = 'settings-gemba-walk-previous-comments-time-config'
export const GEMBA_WALK_SOURCE = 'dr_gemba_walk'
export const GEMBA_WALK_TEMPLATE = 'dr-gemba-walk'

export const GEMBA_WALK_BY_CHECKPOINT_ALERTS_CHART_KEY = 'gw_by_checkpoint_alerts'
export const GEMBA_WALK_BY_CHECKPOINT_NOKS_CHART_KEY = 'gw_by_checkpoint_noks'
export const GEMBA_WALK_BY_CHECKPOINT_TREND_CHART_KEY = 'gw_by_checkpoint_trend'
export const GEMBA_WALK_CHECKPOINT_ALERTS_CHART_KEY = 'gw_checkpoint_alerts'
export const GEMBA_WALK_CHECKPOINT_NOKS_CHART_KEY = 'gw_checkpoint_noks'
export const GEMBA_WALK_CHECKPOINT_SCHEDULE_COUNT_CHART_KEY = 'gw_schedule_count'

export const GEMBA_WALK_BY_CHECKPOINT_TABLE_NAME = 'GW_BY_CHECK_POINT'

export const FREQUENCIES = {
  'DAILY_FREQUENCY': 0,
  'WEEKLY_FREQUENCY': 1,
  'MONTH_FREQUENCY': 2,
  'HOURLY_FREQUENCY': 4,
}

export const GW_DASHBOARD_DATA_TYPES = {
  LAST_VALUE: {
    value: 0,
    token: 'gemba_walk.messages.last_value',
    iconName: 'Filter1',
  },
  TREND_GRAPH: {
    value: 1,
    token: 'gemba_walk.messages.tend_graph',
    iconName: 'TrendingUp',
  },
  SUM: {
    value: 2,
    token: 'common.messages.sum',
    iconName: 'AddCircle',
  },
  AVERAGE: {
    value: 3,
    token: 'common.messages.avg_title',
    iconName: 'JoinInner',
  },
  QUOTIENT: {
    value: 4,
    token: 'common.messages.percentage_value',
    iconName: 'Percent',
  },
}

export const GW_DASHBOARD_VIEW_TYPE_OPTIONS = Object.freeze({
  single: {
    value: 0,
    token: 'gemba_walk.messages.single_data',
    iconName: 'Workspaces',
  },
  aggregated: {
    value: 1,
    token: 'gemba_walk.messages.aggregated_data',
    iconName: 'Tenancy',
  },
})

export const GW_DASHBOARD_FUNCTION_OPTIONS = Object.freeze({
  sum: {
    value: 0,
    token: 'common.messages.sum',
  },
  average: {
    value: 1,
    token: 'common.messages.avg_title',
  },
  quotient: {
    value: 2,
    token: 'common.messages.percentage_value',
  },
})
